import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useBusinessContext } from "../../../../context/business";
import moment from "moment";
import numeral from "numeral";
import Input from "../../../common/Input/Input";
import getDsicount from "../../../../actions/getDiscount";
// import getTotalCost from "../../../../actions/getTotalCost";

export default function Summary({ currentStepIndex }) {
  const {
    selectedBusiness,
    setSelectedBusiness,
    businessData: { businessData },
  } = useBusinessContext();
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountSet, setDiscountSet] = useState(false);
  const [discountOn, setDiscountOn] = useState(false);
  const [servicesCost, setServicesCost] = useState(0);
  const codeForm = useRef();
  const business_id = businessData.id;
  const applyDiscount = async (e) => {
    e.preventDefault();

    const form = codeForm.current;
    const discount_code = form.code.value.toUpperCase();

    if (selectedBusiness?.services?.length === 0) {
      toast.error("Please select a service before applying discount!", {
        duration: 10000,
      });
      return;
    }

    if (discount && discount_code === discount.code.toUpperCase()) {
      toast.error("Discount code already applied", { duration: 10000 });
      return;
    }

    const disco = await getDsicount({ business_id, discount_code, body: {} });
    // const totalServicesCost = selectedBusiness?.totalCost?.total_services_cost || 0;

    if (disco.data.status) {
      const discountData = disco.data.data;
      let discountAmount = 0;

      if (discountData.type === "percentage") {
        discountAmount = (discountData.value / 100) * servicesCost;
      } else {
        discountAmount = discountData.value;
      }
      let serviice_cost = [...selectedBusiness.services]
        .map((service) => service.price)
        .reduce(function (a, b) {
          return a + b;
        });

      if (serviice_cost - discountAmount <= 0) {
        toast.error("You can not apply this discount code!", {
          duration: 10000,
        });
        return false;
      }
      // const newTotal = Math.max(0, serviice_cost - discountAmount);

      setDiscount(discountData);
      setDiscountSet(true);
      setDiscountAmount(discountAmount);
      try {
        localStorage.setItem("discount_code", discountData.code);
      } catch (err) {

      }
      setSelectedBusiness({ type: "ADD_DISCOUNT", data: discountData });
      toast.success(disco.data.message, { duration: 10000 });
    } else {
      setDiscountSet(false);
      setDiscount(null);
      try {
        localStorage.removeItem("discount_code");
      } catch (re) {

      }
      setSelectedBusiness({ type: "ADD_DISCOUNT", data: null });

      toast.error(disco.data.message || "Bad Request", { duration: 10000 });
    }
  };

  useEffect(() => {
    setDiscountSet(false);
    setDiscount(null);

    const servicesCost =
      [...selectedBusiness.services]
        .map((service) => service.price)
        .reduce(function (a, b) {
          return a + b;
        }, 0) * (businessData?.upfront_percentage_payment / 100 || 1);
    setServicesCost(servicesCost);
    try {
      localStorage.removeItem("discount_code");
    } catch (e) {}

  }, [selectedBusiness?.services?.length]);

  useEffect(() => {
    setTotal(selectedBusiness?.totalCost?.total_services_cost);
  }, [selectedBusiness?.totalCost]);


  return (
    <>
      <div className="summary card">
        <p className="header border_bottom">Summary</p>

        {selectedBusiness?.services?.length > 0 ? (
          <div className="services border_bottom">
            {selectedBusiness?.services?.map((service) => (
              <div className="service flex">
                <div className="service_info">
                  <p className="name">{service.name}</p>
                  <p className="time">{service.duration} mins</p>
                </div>
                <div className="price">
                  {service.discount_applied && (
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#999",
                        marginRight: "8px",
                      }}
                    >
                      ₦{numeral(service.price_before_discount).format("0,0.00")}
                    </span>
                  )}
                  ₦{numeral(service.price).format("0,0.00")}
                </div>
              </div>
            ))}
          </div>
        ) : null}

        {selectedBusiness?.services?.[0]?.is_group_session && currentStepIndex === 3 && (
          <div className="quantity-section border_bottom">
            <div className="flex">
              <p className="heading">Number of people</p>
              <div className="quantity-stepper">
                <button
                  type="button"
                  className="quantity-btn quantity-btn-minus"
                  onClick={() => {
                    const currentQty = selectedBusiness?.services?.[0]?.quantity || 1;
                    const newQuantity = Math.max(1, currentQty - 1);
                    setSelectedBusiness({
                      type: "UPDATE_SERVICE_QUANTITY",
                      data: {
                        id: selectedBusiness.services[0].id,
                        quantity: newQuantity,
                      },
                    });
                  }}
                  disabled={(selectedBusiness?.services?.[0]?.quantity || 1) <= 1}
                >
                  −
                </button>
                <input
                  type="number"
                  className="quantity-input"
                  min="1"
                  value={selectedBusiness?.services?.[0]?.quantity || 1}
                  onChange={(e) => {
                    const newQuantity = Math.max(1, parseInt(e.target.value) || 1);
                    setSelectedBusiness({
                      type: "UPDATE_SERVICE_QUANTITY",
                      data: {
                        id: selectedBusiness.services[0].id,
                        quantity: newQuantity,
                      },
                    });
                  }}
                />
                <button
                  type="button"
                  className="quantity-btn quantity-btn-plus"
                  onClick={() => {
                    const currentQty = selectedBusiness?.services?.[0]?.quantity || 1;
                    const maxQty = selectedBusiness?.services?.[0]?.max_capacity || 100;
                    const newQuantity = Math.min(maxQty, currentQty + 1);
                    setSelectedBusiness({
                      type: "UPDATE_SERVICE_QUANTITY",
                      data: {
                        id: selectedBusiness.services[0].id,
                        quantity: newQuantity,
                      },
                    });
                  }}
                  disabled={(selectedBusiness?.services?.[0]?.quantity || 1) >= (selectedBusiness?.services?.[0]?.max_capacity || 100)}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        )}

        {!selectedBusiness?.staff?.hide_member && selectedBusiness?.staff ? (
          <div className="staff border_bottom">
            <p className="heading">Staff Selected</p>
            <div className="flex">
              {selectedBusiness?.staff.profile_picture ? (
                <img
                  src={selectedBusiness?.staff.profile_picture}
                  alt=""
                  srcset=""
                  className="profile_picture"
                />
              ) : (
                <p className="initials">
                  {selectedBusiness?.staff.first_name[0]}
                  {selectedBusiness?.staff.last_name[0]}
                </p>
              )}
              <div className="text_holder">
                <p className="name">
                  {selectedBusiness?.staff.first_name}{" "}
                  {selectedBusiness?.staff.last_name}
                </p>
                {!!selectedBusiness?.staff?.role && (
                  <p className="role">{selectedBusiness?.staff?.role}</p>
                )}
              </div>
            </div>
          </div>
        ) : null}

        {selectedBusiness.date ? (
          <div className="date_time border_bottom">
            <p className="heading">Date Selected</p>
            <p className="role">
              {moment(new Date(selectedBusiness.date)).format("MMM Do YYYY")},{" "}
              {selectedBusiness.hour}
            </p>
          </div>
        ) : null}

        <>
          {selectedBusiness?.services?.length > 0 && selectedBusiness?.totalCost?.auto_discounts_on_checkout.length === 0 ? (
            <div
              onClick={() => {
                setDiscountOn(discountOn ? false : true);
              }}
              className="flex center co-pink link ft-14"
              style={{ alignItems: "center", cursor: "pointer" }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_625_415)">
                  <path
                    d="M16.6992 7.25853V3.33353H12.7826L9.99922 0.575195L7.25755 3.33353H3.33255V7.25853L0.574219 10.0002L3.33255 12.7835V16.7002H7.25755L9.99922 19.4585L12.7826 16.7002H16.6992V12.7835L19.4576 10.0002L16.6992 7.25853ZM7.35755 5.8752C8.17422 5.8752 8.83255 6.53353 8.83255 7.35853C8.83255 7.74972 8.67715 8.1249 8.40054 8.40151C8.12392 8.67813 7.74875 8.83353 7.35755 8.83353C6.53255 8.83353 5.87422 8.1752 5.87422 7.35853C5.87422 6.53353 6.53255 5.8752 7.35755 5.8752ZM12.6826 14.1669C11.8659 14.1669 11.2076 13.5002 11.2076 12.6835C11.2076 12.2923 11.363 11.9172 11.6396 11.6405C11.9162 11.3639 12.2914 11.2085 12.6826 11.2085C13.4992 11.2085 14.1659 11.8669 14.1659 12.6835C14.1659 13.0769 14.0096 13.4542 13.7314 13.7324C13.4532 14.0106 13.076 14.1669 12.6826 14.1669ZM7.08255 14.1919L5.83255 12.9419L12.9409 5.83353L14.1909 7.08353L7.08255 14.1919Z"
                    fill="#E40587"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_625_415">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span style={{ marginLeft: "5px" }}> Apply Discount Code</span>
            </div>
          ) : (
            ""
          )}
          {discountOn && selectedBusiness?.totalCost?.auto_discounts_on_checkout.length === 0 ? (
            <div>
              <br></br>
              <form onSubmit={applyDiscount} className="flex" ref={codeForm}>
                <Input
                  label="Code"
                  placeholder="Enter code"
                  required
                  name="code"
                />
                <button
                  style={{
                    marginLeft: "10px",
                    padding: "14px 20px",
                    fontSize: "14px",
                    width: "100px",
                  }}
                  className="round_button"
                  type="submit"
                >
                  Apply
                </button>
              </form>
            </div>
          ) : (
            ""
          )}
          <br></br>
          <div className="border_bottom">
            {selectedBusiness?.totalCost ? (
              <div className="flex fee">
                <p>
                  Services ({businessData?.upfront_percentage_payment}% upfront){selectedBusiness?.services?.[0]?.is_group_session && <span className="quantity-text"> ×{selectedBusiness?.services?.[0]?.quantity}</span>}
                </p>
                {selectedBusiness?.totalCost?.auto_discounts_on_checkout.length === 0 && <p>
                  ₦
                  {numeral(
                    [...selectedBusiness.services]
                      .map((service) => service.price * (service.is_group_session ? (service.quantity || 1) : 1))
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0) *
                    (businessData?.upfront_percentage_payment / 100 || 1)
                  ).format("0,0.00")}
                </p>}
                {selectedBusiness?.totalCost?.auto_discounts_on_checkout.length > 0 && <p>
                  ₦
                  {numeral(
                    [...selectedBusiness.services]
                      .map((service) => service.price_before_discount * (service.is_group_session ? (service.quantity || 1) : 1))
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0) *
                    (businessData?.upfront_percentage_payment / 100 || 1)
                  ).format("0,0.00")}
                </p>}
              </div>
            ) : (
              ""
            )}
            {discountSet ? (
              <div className="flex fee">
                <p>Discount: {discount.code}</p>
                <p style={{ opacity: "0.5" }}>
                  -₦{numeral(selectedBusiness?.totalCost?.discount_amount).format("0,0.00")}
                </p>
              </div>
            ) : (
              ""
            )}

            {selectedBusiness?.totalCost?.auto_discounts_on_checkout.length ? (
              <div className="flex fee">
                <p>Discount: {selectedBusiness?.totalCost?.auto_discounts_on_checkout[0]}</p>
                <p style={{ opacity: "0.5" }}>
                  ₦{numeral(selectedBusiness?.totalCost?.discount_amount).format("0,0.00")}
                </p>
              </div>
            ) : (
              ""
            )}


            {businessData?.priority_booking > 0 &&
              selectedBusiness?.services?.length > 0 ? (
              <div className="flex fee">
                <p>Priority booking</p>
                <p>₦{businessData?.priority_booking}</p>
              </div>
            ) : (
              ""
            )}
            {selectedBusiness?.totalCost?.rizevo_commission > 0 ? (
              businessData?.handles_processing_fee !== "business" ? (
                <div className="flex fee">
                  <p>Processing Fees</p>
                  <p>
                    ₦
                    {numeral(
                      selectedBusiness?.totalCost?.rizevo_commission
                    ).format("0,0.00")}
                  </p>
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          {selectedBusiness?.totalCost ? (
            <div className="border_bottom">
              <div className="flex fee total">
                <p>Total</p>
                <p>₦{numeral(total).format("0,0.00")}</p>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      </div>
    </>
    // )
  );
}
